import { Dayjs } from "dayjs";

export const formatToDateDefault = (date: Dayjs): string => {
    
    let day: number | string = date.date();
    if (Number.isNaN(day)) {
        return '';
    }

    if (day < 10) {
        day = `0${day}`;
    }

    let month: number | string = date.month() + 1;
    if (Number.isNaN(month)) {
        return '';
    }

    if (month < 10) {
        month = `0${month}`;
    }

    const year = date.year();
    if (Number.isNaN(year)) {
        return '';
    }

    return `${year}-${month}-${day}`;
}